import cloneDeep from 'lodash/cloneDeep';
import { generationEcheancierPaiement } from '@/api/echeancierPaiement/index';
import formatDate from '@/services/general/formatIsoDate';
import gestionDateBase from '@/services/general/gestionDateBase';
import { TRIMESTRIEL, SEMESTRIEL, MOIS } from '@/configuration/devisConf';
import calculArrondi from '@/services/calcul/calculArrondi';

export default async function echeancierGeneration(generation) {
  const data = cloneDeep(generation);
  data.datePremiereEcheance = formatDate(data.datePremiereEcheance);
  data.montantTotal = calculArrondi(data.montantTotal);
  const quantiteMois = {
    [TRIMESTRIEL]: 3,
    [SEMESTRIEL]: 6,
  };
  if (Object.keys(quantiteMois).includes(data.periodicite)) {
    data.quantitePeriodicite = quantiteMois[data.periodicite];
    data.periodicite = MOIS;
  }
  const response = await generationEcheancierPaiement(data);
  if (response.data.result) {
    response.data.result.forEach((element) => {
      element.dateEcheance = gestionDateBase(element.dateEcheance);
    });
  }
  return response;
}
